package tta.destinigo.talktoastro.feature_profile.transaction_history.data.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class TransactionOrderHistory(
    @SerialName("code")
    val code: Int,
    @SerialName("data")
    val `data`: List<TransactionOrderData>? ,
    @SerialName("message")
    val message: String,
    @SerialName("status")
    val status: Boolean
)
